<!-- eslint-disable no-undef -->
<template>
  <div>
    <div class="modal fade" tabindex="-1" role="dialog" id="newCardModal">
      <div class="modal-dialog" role="document">
        <form @submit.prevent="diffCardPayment">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title label">Card Details</h5>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label for="nameOnCard">Name on Card</label>
                <input
                  class="form-control"
                  type="text"
                  name="nameOnCard"
                  id="nameOnCard"
                  v-model="otherCardForm.nameOnCard"
                  required
                />
              </div>
              <div class="form-group">
                <label for="accountNo">Account No.</label>
                <input
                  required
                  type="number"
                  name="accountNo"
                  id="accountNo"
                  class="form-control"
                  v-model="otherCardForm.acctNum"
                  maxlength="20"
                />
              </div>
              <div class="form-group">
                <div class="row form-group pb-3">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="col-form-label" for="formGroupExampleInput"
                        >Month</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        placeholder=""
                        maxlength="2"
                        v-model="otherCardForm.month"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="col-form-label">Year</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder=""
                        maxlength="2"
                        v-model="otherCardForm.year"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="cardCode">Card Code</label>
                <input
                  required
                  type="text"
                  name="cardCode"
                  id="cardCode"
                  class="form-control"
                  v-model="otherCardForm.cardCode"
                  maxlength="4"
                />
              </div>
              <div class="form-group">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="otherCardForm.saveAlias"
                  />
                  <label class="form-check-label" for="flexCheckDefault">
                    Save card for future use?
                  </label>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary">Submit</button>
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- Fortis payment modal -->
    <div class="modal fade" tabindex="-1" role="dialog" id="fortisPaymentModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Payment</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="!fortisPaymentViaUrl.value" class="text-center">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <p class="mt-2">Loading payment form...</p>
            </div>
            <div v-else-if="fortisPaymentError" class="alert alert-danger">
              {{ fortisPaymentError }}
            </div>
            <FortisCardPayment v-else :key="fortisPaymentKey" />
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <h2>
        Statement {{ statementInfo.StatementDate }}
        <span
          title="Download File"
          class="ml-2"
          style="cursor: pointer"
          @click="viewFileInTab(statementInfo.FileID)"
          ><i class="fa-solid fa-file-pdf"></i
        ></span>
      </h2>
      <div v-if="statementInfo" class="ml-3">
        <div class="row">
          <div class="d-inline p-1"><strong>Statement Date:</strong></div>
          <div class="d-inline p-1">
            {{ statementInfo.StatementDate }}
          </div>
        </div>
        <div class="row">
          <div class="d-inline p-1"><strong>Total Due:</strong></div>
          <div class="d-inline p-1">
            {{ evenRound(statementInfo.TotalDue, 2, 'money') }}
          </div>
        </div>
        <div class="row"></div>
      </div>
      <hr />
      <fieldset v-if="canProcess">
        <form class="col-lg-7" @submit.prevent="makePayment">
          <div class="row mb-1">
            <div class="col-lg-6">
              <label>Amount to Pay</label>
              <input
                type="number"
                step="0.01"
                class="form-control"
                placeholder="Enter Amount"
                required
                v-model="form.totalDue"
              />
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-lg-6">
              <label>Email address for receipt</label>
              <input
                type="email"
                class="form-control"
                placeholder="Enter Email"
                required
                v-model="form.email"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <h5 v-if="creditCardList.length > 0">Select Payment Method</h5>
              <div class="credit-cards-container">
                <div
                  v-for="(cc, index) in creditCardList"
                  :key="index"
                  @click="selectCard(cc)"
                  class="credit-card-wrapper"
                >
                  <div
                    class="credit-card"
                    :class="[
                      setCardClass(cc.paymentMethod),
                      { 'card-selected': cc.selected }
                    ]"
                  >
                    <div class="credit-card-last4">
                      {{ displayAcctNo(cc.accountNo) }}
                    </div>
                    <div class="credit-card-expiry mt-2">
                      {{ displayCardExp(cc) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <hr />
            </div>
          </div>
          <div
            class="row justify-content-center mb-3"
            v-if="creditCardList.length >= 1"
          >
            <div class="col">
              <btn-saving
                :is-disabled="isDisabledPayment"
                :is-saving="isSaving"
                :loading-text="'Processing payment ...'"
                :display-text="'Make Payment'"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <div
                class="form-group form-check mb-1"
                v-if="creditCardList.length > 0"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="form.fortisSaveAlias"
                />
                <label class="form-check-label">Pay with different card</label>
              </div>
              <div
                class="form-group form-check mb-1"
                v-if="form.fortisSaveAlias || creditCardList.length === 0"
              >
                <label class="form-check-label">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    v-model="form.storeCardForFutureUse"
                  />
                  Store card for future use
                </label>
              </div>
              <div
                class="form-group"
                v-if="
                  form.storeCardForFutureUse &&
                  (form.fortisSaveAlias || creditCardList.length === 0)
                "
              >
                <input
                  type="text"
                  class="form-control"
                  placeholder="Description of the card"
                  v-model="form.fortisAlias"
                  required
                />
              </div>
            </div>
          </div>
          <div
            class="row my-2"
            v-if="form.fortisSaveAlias || creditCardList.length === 0"
          >
            <div class="col">
              <button
                class="btn btn-default"
                type="button"
                @click="payWithDiffCard"
              >
                Enter Card Information
              </button>
            </div>
          </div>
        </form>
      </fieldset>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import api from '../../api/http-common.js'
import BtnSaving from '../../components/button-saving.vue'
import FortisCardPayment from './FortisCardPayment.vue'

export default {
  components: {
    BtnSaving,
    FortisCardPayment
  },
  data() {
    return {
      pubNubMsg: {
        channel: '',
        msg: []
      },
      facilityInfo: null,
      isSaving: false,
      creditCardList: [],
      form: {
        totalDue: 0,
        cardInfo: null,
        isManual: false,
        email: '',
        taskId: '',
        saveAlias: false,
        fortisSaveAlias: false,
        fortisAlias: ''
      },
      otherCardForm: {
        nameOnCard: '',
        acctNum: '',
        expDate: '',
        month: '',
        year: '',
        cardCode: '',
        saveAlias: false
      },
      fortisPaymentViaUrl: {
        id: 0,
        channel: '',
        messageTypeId: 58,
        reason: '',
        value: false
      },
      isFortisPaymentViaElements: false,
      storeCardForFutureUse: false,
      fortisPaymentError: null,
      fortisPaymentKey: 0 // Add this to force component remount
    }
  },
  computed: {
    ...mapGetters([
      'currentPatientAssociated',
      'getBillingTaskStatement',
      'getProfileAuthInfo',
      'getFacilityInfo'
    ]),
    isDisabledPayment() {
      if (!this.form.cardInfo) {
        return true
      }
      return false
    },
    canProcess() {
      if (!this.facilityInfo) {
        return false
      }

      return this.facilityInfo.openEdge || this.facilityInfo.fortis
    },
    statementInfo() {
      if (!this.getBillingTaskStatement) {
        return null
      }

      const info = JSON.parse(this.getBillingTaskStatement.info)
      return info
    },
    cardText() {
      if (this.creditCardList.length === 0 && !this.facilityInfo.fortis) {
        return 'Enter Card Information'
      }
      return 'Pay with different card'
    }
  },
  methods: {
    ...mapActions([
      'setFacilityInfo',
      'setFortisPaymentForm',
      'setFortisStatementInfo',
      'setFortisPaymentUrl'
    ]),
    // https://stackoverflow.com/questions/3108986/gaussian-bankers-rounding-in-javascript
    evenRound(num, decimalPlaces, hasFormat) {
      try {
        if (!num) {
          return ''
        }
        var d = decimalPlaces || 0
        var m = Math.pow(10, d)
        var n = +(d ? num * m : num).toFixed(8) // Avoid rounding errors
        var i = Math.floor(n)
        var f = n - i
        var e = 1e-8 // Allow for rounding errors in f
        var r =
          f > 0.5 - e && f < 0.5 + e ? (i % 2 === 0 ? i : i + 1) : Math.round(n)
        let retVal = d ? r / m : r

        switch (hasFormat) {
          case 'comma':
            // console.log("retVal>", retVal)
            retVal = Number(retVal).toLocaleString(undefined, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            })
            break
          case 'money':
            retVal = Number(retVal).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })
            retVal = '$ ' + retVal
            break
          case 'percent':
            retVal = Number(retVal).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })
            retVal = retVal + ' %'
            break
          default:
            // console.log("retVal>", retVal)
            retVal = Number(retVal).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })
            break
        }
        return retVal
      } catch (ex) {
        console.error('error> ' + ex)
      }
    },
    setCardClass(cardBrand) {
      if (!cardBrand) {
        return 'visa selectable' // Default fallback
      }
      switch (cardBrand.toLowerCase()) {
        case 'mc':
          return 'mastercard selectable'
        case 'disc':
          return 'discover selectable'
        case 'amex':
          return 'amex selectable'
        default:
          return `${cardBrand.toLowerCase()} selectable`
      }
    },
    displayAcctNo(acctNo) {
      if (!acctNo) {
        return '****'
      }
      if (acctNo.length > 4) {
        return acctNo.substring(acctNo.length - 4)
      }
      return acctNo
    },
    displayCardExp(cardInfo) {
      if (!cardInfo) {
        return 'MM/YY'
      }
      if (cardInfo.expDate) {
        const expData = moment(cardInfo.expDate).format('MM/YY')
        return expData
      } else {
        const month = cardInfo.month || 'MM'
        const year = cardInfo.year || 'YY'
        return `${month}/${year}`
      }
    },
    selectCard(cardInfo) {
      this.creditCardList.forEach((el) => {
        el.selected = false
      })
      cardInfo.selected = true
      // console.log('cardInfo>', cardInfo)
      if (cardInfo.merchantPaymentMethodID) {
        this.form.cardInfo = cardInfo.merchantPaymentMethodID
        this.form.isManual = false
        // console.log('this.form.isManual>', this.form.isManual)
      } else {
        this.form.cardInfo = cardInfo
        this.form.isManual = true
        this.form.saveAlias = cardInfo.saveAlias
      }
    },
    async payWithDiffCard() {
      if (this.facilityInfo.openEdge) {
        this.otherCardForm = {
          nameOnCard: '',
          accountNo: '',
          expDate: '',
          cardCode: ''
        }
        // eslint-disable-next-line no-undef
        $('#newCardModal').modal({
          show: true,
          backdrop: 'static'
        })
      }
      if (this.facilityInfo.fortis) {
        if (this.form.storeCardForFutureUse && !this.form.fortisAlias) {
          this.$swal({
            text: 'Please specify the card alias',
            position: 'top-center',
            title: 'Store Card for Future use',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 2000,
            icon: 'error'
          })
          return
        }

        // Reset any previous error and increment key to force remount
        this.fortisPaymentError = null
        this.fortisPaymentKey++

        // Show modal with loading state
        // eslint-disable-next-line no-undef
        $('#fortisPaymentModal').modal({
          show: true,
          backdrop: 'static'
        })

        try {
          // Unsubscribe from previous channel if exists
          if (this.pubNubMsg.channel) {
            this.$pnUnsubscribe({
              channels: [this.pubNubMsg.channel + '-done']
            })
          }

          const payload = {
            facilityId: this.currentPatientAssociated.facilityID,
            patientId: this.currentPatientAssociated.patientID,
            amount: parseFloat(this.form.totalDue),
            email: this.form.email,
            statementBatchID: this.statementInfo.StatementBatchID,
            taskId: this.form.taskId,
            saveAlias: false,
            saveTitle: '',
            timestamp: Date.now() // Add timestamp to ensure fresh URL
          }
          if (this.form.fortisAlias) {
            payload.saveAlias = true
            payload.saveTitle = this.form.fortisAlias
          }

          console.log(
            'Requesting new Fortis payment URL with payload:',
            payload
          )
          var paymentUrlResponse =
            await api.patient.request.getFortisTransactionUrl(payload)

          console.log(
            'Received new Fortis payment URL response:',
            paymentUrlResponse
          )

          if (!paymentUrlResponse.data) {
            throw new Error('Unable to acquire the payment setup')
          }
          if (!paymentUrlResponse.data.value) {
            throw new Error(
              paymentUrlResponse.data.reason || 'Unable to get payment URL'
            )
          }

          // set vuex objects for fortis payment
          this.setFortisPaymentUrl(paymentUrlResponse.data)
          this.setFortisPaymentForm(this.form)
          this.setFortisStatementInfo(this.statementInfo)

          this.fortisPaymentViaUrl = paymentUrlResponse.data
          this.pubNubMsg.channel = this.fortisPaymentViaUrl.channel

          const pnInstance = this.$pnGetInstance()

          pnInstance.subscribe({
            channels: [this.fortisPaymentViaUrl.channel + '-done']
          })

          // Handle the payment completion
          this.$pnGetMessage(
            this.fortisPaymentViaUrl.channel + '-done',
            this.paymentComplete
          )
        } catch (error) {
          console.error('Fortis payment setup error:', error)
          this.fortisPaymentError =
            error.message || 'An error occurred setting up the payment'
          this.$swal({
            text: this.fortisPaymentError,
            position: 'top-center',
            title: 'Error',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 2000,
            icon: 'error'
          })
        }
      }
    },
    async paymentComplete(pubnubMsg) {
      console.log('payment complete>', pubnubMsg)
      this.$pnUnsubscribe({
        channels: [this.fortisPaymentViaUrl.channel + '-done']
      })

      // Close the Fortis payment modal
      // eslint-disable-next-line no-undef
      $('#fortisPaymentModal').modal('hide')

      this.$swal({
        text: 'Payment successful',
        position: 'top-center',
        title: 'Payment',
        showConfirmButton: false,
        timerProgressBar: true,
        timer: 5000,
        icon: 'success'
      })
      this.$router.push('/menu/tasks')
    },
    diffCardPayment() {
      this.form.cardInfo = this.otherCardForm
      this.creditCardList.forEach((el) => {
        el.selected = false
      })
      this.form.cardInfo.paymentMethod = this.getCardType(
        this.form.cardInfo.acctNum
      )
      this.form.cardInfo.selected = true
      this.form.cardInfo.accountNo = this.form.cardInfo.acctNum.substring(
        this.form.cardInfo.acctNum.length - 4
      )
      this.creditCardList.push(this.form.cardInfo)
      this.form.isManual = true
      this.form.saveAlias = this.otherCardForm.saveAlias
      // eslint-disable-next-line no-undef
      $('#newCardModal').modal('toggle')
    },
    getCardType(accountNum) {
      const number = accountNum
      let re = new RegExp('^4')
      if (number.match(re) != null) return 'visa'

      re = new RegExp('^(34|37)')
      if (number.match(re) != null) return 'amex'

      re = new RegExp('^5[1-5]')
      if (number.match(re) != null) return 'mastercard'

      re = new RegExp('^6011')
      if (number.match(re) != null) return 'discover'

      re = new RegExp('^9792')
      if (number.match(re) != null) return 'troy'

      return 'visa' // default type
    },
    async downloadFile(fileId) {
      try {
        // Show loading state
        this.$store.dispatch('setIsLoading', true)

        const file = await api.patient.request.downloadfilebase64({
          facilityId: this.currentPatientAssociated.facilityID,
          id: fileId
        })
        // Convert base64 to binary
        const byteCharacters = atob(file.data.base64)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)

        // Determine MIME type based on file extension
        const getMimeType = (filename) => {
          const extension = filename.split('.').pop().toLowerCase()
          const mimeTypes = {
            pdf: 'application/pdf',
            doc: 'application/msword',
            docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            xls: 'application/vnd.ms-excel',
            xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            txt: 'text/plain',
            jpg: 'image/jpeg',
            jpeg: 'image/jpeg',
            png: 'image/png',
            gif: 'image/gif',
            bmp: 'image/bmp',
            tiff: 'image/tiff',
            csv: 'text/csv',
            rtf: 'application/rtf',
            zip: 'application/zip',
            rar: 'application/x-rar-compressed'
          }
          return mimeTypes[extension] || file.data.mimeType || 'application/octet-stream'
        }

        const filename = file.data.originalFileName || `document_${fileId}`
        const mimeType = getMimeType(filename)
        const blob = new Blob([byteArray], { type: mimeType })

        // Create download link with proper filename
        const url = URL.createObjectURL(blob)

        // Use a more reliable download method
        this.downloadFileLink(url, filename)

        // Clean up the object URL after a short delay
        setTimeout(() => {
          URL.revokeObjectURL(url)
        }, 100)
      } catch (error) {
        console.error('Download failed:', error)
      } finally {
        // Hide loading state
        this.$store.dispatch('setIsLoading', false)
      }
    },
    downloadFileLink(url, filename) {
      // Create and configure download link
      const link = document.createElement('a')
      link.href = url
      link.download = filename

      // Ensure the link is styled to be invisible
      link.style.display = 'none'

      // Add to document, click, and remove immediately
      document.body.appendChild(link)

      // Trigger download - this must happen synchronously
      link.click()

      // Clean up immediately
      document.body.removeChild(link)
    },
    async viewFileInTab(fileId) {
      await this.downloadFile(fileId)
    },
    async makePaymentOpenEdge() {
      try {
        this.isSaving = true
        if (!this.form.cardInfo) {
          this.$swal({
            text: 'Please select a payment method.',
            position: 'top-center',
            title: 'Payment Error',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 2000,
            icon: 'error'
          })
          return
        }
        const payload = {
          facilityId: this.currentPatientAssociated.facilityID,
          patientId: this.currentPatientAssociated.patientID,
          amount: parseFloat(this.form.totalDue),
          email: this.form.email,
          statementBatchID: this.statementInfo.StatementBatchID,
          taskId: this.form.taskId,
          saveAlias: this.form.saveAlias
        }
        if (this.form.isManual) {
          payload.nameOnCard = this.form.cardInfo.nameOnCard
          payload.acctNum = this.form.cardInfo.acctNum
          payload.expDate = `${this.form.cardInfo.month}${this.form.cardInfo.year}`
          payload.cardCode = this.form.cardInfo.cardCode
        } else {
          payload.alias = this.form.cardInfo
          payload.nameOnCard = ''
          payload.acctNum = ''
          payload.expDate = ''
          payload.cardCode = ''
        }
        const response = await api.patient.request.makeStatementPayment(payload)
        if (!response.data.value) {
          this.$swal({
            text: response.data.reason,
            position: 'top-center',
            title: 'Payment Error',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 4000,
            icon: 'error'
          })
        } else {
          this.$swal({
            text: response.data.reason,
            position: 'top-center',
            title: 'Payment Success',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 5000,
            icon: 'success'
          })

          setTimeout(() => {
            this.$router.push('/menu/tasks')
          }, 1000)
        }
      } catch (ex) {
        this.$swal({
          text: 'Exception occured. Please try processing again.',
          position: 'top-center',
          title: 'Error',
          showConfirmButton: false,
          timerProgressBar: true,
          timer: 2000,
          icon: 'error'
        })
      } finally {
        this.isSaving = false
      }
    },
    async makePaymentFortis() {
      try {
        this.isSaving = true
        if (!this.form.cardInfo) {
          this.$swal({
            text: 'Please select a payment method.',
            position: 'top-center',
            title: 'Payment Error',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 2000,
            icon: 'error'
          })
          return
        }
        const payload = {
          facilityId: this.currentPatientAssociated.facilityID,
          patientId: this.currentPatientAssociated.patientID,
          amount: this.evenRound(this.form.totalDue, 2),
          statementBatchID: this.statementInfo.StatementBatchID,
          taskId: this.form.taskId,
          alias: this.form.cardInfo
        }

        // console.log('payload>', payload)
        const response =
          await api.patient.request.makeStatementPaymentViaFortis(payload)
        if (!response.data.value) {
          this.$swal({
            text: response.data.reason,
            position: 'top-center',
            title: 'Payment Error',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 4000,
            icon: 'error'
          })
        } else {
          this.$swal({
            text: response.data.reason,
            position: 'top-center',
            title: 'Payment Success',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 5000,
            icon: 'success'
          })

          setTimeout(() => {
            this.$router.push('/menu/tasks')
          }, 1000)
        }
      } catch (ex) {
        this.$swal({
          text: 'Exception occured. Please try processing again.',
          position: 'top-center',
          title: 'Error',
          showConfirmButton: false,
          timerProgressBar: true,
          timer: 2000,
          icon: 'error'
        })
      } finally {
        this.isSaving = false
      }
    },
    async makePayment() {
      if (!this.facilityInfo.openEdge && !this.facilityInfo.fortis) {
        this.$swal({
          text: 'Facility payment processing not available',
          position: 'top-center',
          title: 'Payment Processing Error',
          showConfirmButton: false,
          timerProgressBar: true,
          timer: 2000,
          icon: 'error'
        })
        return
      }

      if (this.facilityInfo.openEdge) {
        await this.makePaymentOpenEdge()
      }
      if (this.facilityInfo.fortis) {
        if (this.creditCardList && this.creditCardList.length > 0) {
          await this.makePaymentFortis()
        }
      }
    },
    handleIframeLoad(event) {
      console.log('Iframe loaded successfully')
      this.fortisPaymentError = null

      // Check if the iframe loaded a valid page
      try {
        const iframe = event.target
        // If we can't access the contentWindow, it might be a cross-origin issue
        if (!iframe.contentWindow) {
          console.log('Cannot access iframe content - likely cross-origin')
          return
        }

        // Try to access the URL to check for errors
        const iframeUrl = iframe.contentWindow.location.href
        console.log('Iframe loaded URL:', iframeUrl)

        // Check if the URL indicates an error page
        if (iframeUrl.includes('error') || iframeUrl.includes('not-found')) {
          this.fortisPaymentError =
            'The payment page could not be loaded. Please try again.'
        }
      } catch (error) {
        // Cross-origin restrictions prevent accessing iframe content
        console.log('Cross-origin restrictions prevent checking iframe content')
      }
    },
    handleIframeError(event) {
      console.error('Iframe loading error:', event)
      this.fortisPaymentError = 'Error loading payment form. Please try again.'

      // Close the modal after a delay if there's an error
      setTimeout(() => {
        // eslint-disable-next-line no-undef
        $('#fortisPaymentModal').modal('hide')
      }, 3000)
    },
    handleModalClose() {
      // Reset Fortis payment state
      this.fortisPaymentViaUrl = {
        id: 0,
        channel: '',
        messageTypeId: 58,
        reason: '',
        value: false
      }
      this.fortisPaymentError = null
      this.fortisPaymentKey++ // Increment to force component remount

      // Unsubscribe from previous channel if exists
      if (this.pubNubMsg.channel) {
        this.$pnUnsubscribe({
          channels: [this.pubNubMsg.channel + '-done']
        })
      }
    }
  },
  async mounted() {
    if (!this.getBillingTaskStatement) {
      this.$swal({
        text: 'No Task found for statement payment!',
        position: 'top-center',
        title: 'Error',
        showConfirmButton: false,
        timerProgressBar: true,
        timer: 2000,
        icon: 'error'
      })
      this.$router.push('/')
      return
    }
    const response = await api.patient.request.getpaymentprofilelist({
      facilityid: this.currentPatientAssociated.facilityID,
      id: this.currentPatientAssociated.patientID
    })
    this.facilityInfo = await api.auth.request.getFacilityInfo(
      this.currentPatientAssociated.facilityID
    )
    this.setFacilityInfo(this.facilityInfo)

    response.data.forEach((el) => {
      el.selected = false
    })
    this.creditCardList = response.data

    if (this.statementInfo) {
      this.form.totalDue = this.statementInfo.TotalDue
    }

    this.form.taskId = this.getBillingTaskStatement.taskID
    this.form.email = this.getProfileAuthInfo.email

    // Add modal close handler
    // eslint-disable-next-line no-undef
    $('#fortisPaymentModal').on('hidden.bs.modal', this.handleModalClose)
  },
  beforeDestroy() {
    // Clean up modal handler
    // eslint-disable-next-line no-undef
    $('#fortisPaymentModal').off('hidden.bs.modal', this.handleModalClose)
  }
}
</script>

<style scoped>
/* CREDIT CARDS CONTAINER */
.credit-cards-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
}

.credit-card-wrapper {
  display: flex;
  justify-content: center;
}

/* MAIN CREDIT CARD CONTAINER */

.credit-card {
  margin: 0;
  border-radius: 12px;
  width: 100%;
  max-width: 280px;
  position: relative;
  transition: all 0.3s ease;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  min-height: 70px;
  padding: 18px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
}

.credit-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  pointer-events: none;
}

.credit-card.selectable:hover {
  cursor: pointer;
  transform: translateY(-2px);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.25);
}

.credit-card.card-selected {
  border: 2px solid #007bff;
  box-shadow: 0 8px 25px rgba(0, 123, 255, 0.3);
  transform: translateY(-1px);
}

/*  NUMBER FORMATTING */

.credit-card-last4 {
  font-family: 'Courier New', 'PT Mono', monospace;
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 30px; /* Add space for expiry date */
  letter-spacing: 2px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.credit-card-last4:before {
  content: '**** **** **** ';
  color: rgba(255, 255, 255, 0.6);
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 1px;
}

.credit-card.american-express .credit-card-last4:before,
.credit-card.amex .credit-card-last4:before {
  content: '**** ****** *';
  margin-right: -10px;
}

.credit-card.diners-club .credit-card-last4:before,
.credit-card.diners .credit-card-last4:before {
  content: '**** ****** ';
}

.credit-card-expiry {
  font-family: 'Courier New', 'PT Mono', monospace;
  font-size: 16px;
  font-weight: 500;
  position: absolute;
  bottom: 12px;
  left: 18px;
  letter-spacing: 1px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

/* BRAND CUSTOMIZATION */

.credit-card.visa {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  color: #ffffff;
}

.credit-card.visa .credit-card-last4:before {
  color: rgba(255, 255, 255, 0.7);
}

.credit-card.mastercard {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: #ffffff;
}

.credit-card.mastercard .credit-card-last4:before {
  color: rgba(255, 255, 255, 0.7);
}

.credit-card.american-express,
.credit-card.amex {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: #ffffff;
}

.credit-card.american-express .credit-card-last4:before,
.credit-card.amex .credit-card-last4:before {
  color: rgba(255, 255, 255, 0.7);
}

.credit-card.diners,
.credit-card.diners-club {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #ffffff;
}

.credit-card.diners .credit-card-last4:before,
.credit-card.diners-club .credit-card-last4:before {
  color: rgba(255, 255, 255, 0.7);
}

.credit-card.discover {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
  color: #ffffff;
}

.credit-card.discover .credit-card-last4:before {
  color: rgba(255, 255, 255, 0.7);
}

.credit-card.jcb {
  background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
  color: #333333;
}

.credit-card.jcb .credit-card-last4:before {
  color: rgba(0, 0, 0, 0.6);
}

.credit-card.unionpay {
  background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
  color: #333333;
}

.credit-card.unionpay .credit-card-last4:before {
  color: rgba(0, 0, 0, 0.6);
}

/*   LOGOS  */

.credit-card::after {
  content: ' ';
  position: absolute;
  bottom: 10px;
  right: 15px;
}

.credit-card.visa::after {
  height: 16px;
  width: 50px;
  background-image: url('data:image/png;base64,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');
}

.credit-card.mastercard::after {
  width: 40px;
  height: 25px;
  background-image: url('data:image/png;base64,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');
}

.credit-card.amex::after,
.credit-card.american-express::after {
  width: 50px;
  height: 14px;
  background-image: url('data:image/png;base64,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');
}

.credit-card.diners::after,
.credit-card.diners-club::after {
  width: 30px;
  height: 24px;
  background-image: url('data:image/png;base64,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');
}

.credit-card.discover::after {
  width: 50px;
  height: 14px;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAOCAYAAABth09nAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAA/tJREFUSA19ll2IVVUUx73jmEYgiUpYiIREkFqQD0FhKiVIoPaSRaEPQlATZmk9JERBQVCSldjHk9iDqE8KQaTQB0lFoljDSGKiFI3VWJZZfo6n32+fta5nrrcW/O/6r8+999n77HNbVVWNHnVZqlardSlNYj1yffAWVFt9qSNPX/axxzB2kehhfERdjNs5njmO4RyyBlok52W80pNziLmVpPaPA8fgnT4btyWL0bmAdixJt1inr9FnRP/s8X+aWuda6lqQmZHsUxxklX9qR8J0Ob7vwzcDPQHsx/cPOb3oixG7A309OIjvELEetDt5Nb5ZwAV/h++kdXB7/Yp9HBvlVKqx+G4Bx4H8WnAejAH6zoCJwB05Rc0faOd6lT8X7BByHv0OuCYSDsA/D64/ZQgyO/yz4P0ZCH1fxJZiH2nEfoGvjNg+eH9wF+ZcHo/ce9EfBE+1FvJkGL+jz4G3wFTQZ7GyHcwFG4CyOxoPwHeB2TqRl8EU8CKYDCaCU+Bv8DBwUW+AuWAeSHFnRMqDkAfCmONYCvZBcDS4D/EwuAvcDyaBV4GyGDxXWFU9gx6fC3m+dKqbZcIcEvaAj4Bc2ZB5Mdibtbu6vemP2LcRO4POhZwN3zH0DeA02B75Tlh5KuxD8E/lKdivm9CwNd8ttgx5pRG8sXZVK9Efg6+Mod8Pv5NaD3zR9oIjEdf2XJtrD3dJGa5V+zd35mY87YnB346MSdHj67B/Cv0Q2uOlrAFbCquqheaXsylpyLjgvkiuvuTwYi2ncD32KuBTGwJeDNcBxdxyXaPz+tTfFHOEN42Lfg88Td8X0EvBVsY5gVYcdxC8BBxjL/AiUNbVatQ88j+jvieP1toIaG8CimfyC2DiOOCNVATuEfHlfxYod2ZMjT0aeMaVbkfLm8rbz1z7p9ytT8ExAD6srfoXeyOwtg8oSyK31wLlS+CknLjSFwlH4Z8Aj5LX7QrgApRHI+fn2iz1C+Bu+T1gfvi7qcfqqZUJPxIJe9IXfV2It9Nq8Bq4DawD7qjz3iZHbi11kH5wGHgWXciiEqiTd2BvAtPBNyBlM8Tvgw2nAS+EFHdrfsSWwX/IANpFPxExvyvWjwe/gXx46d+Jz8vgBFBWBdyRMWACGAQ77dOCWNj5VyE/Zp55eX70bsI+i/0j2kk0P4hTcHlcjhF397JHfhDtNUDsL7S10FY+3am4hrB9CMWP9lvm3IaB79Q5YA/frdMkeWn4oXTMk+Cy2ARccQHgK08pMyOvvNjGtDPW1Pi79ept5v8Xb/bpxqkr42fMiafDR1GeUAZzEP3BSy62T6ktzRjOK3YXX44x4s9mNqDeB2WsPT6+rGmnBSGt/mObOdr/Ap6tK4eqKaaFAAAAAElFTkSuQmCC');
}

.credit-card.jcb::after {
  width: 30px;
  height: 15px;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAPCAYAAADzun+cAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACXBIWXMAAAsTAAALEwEAmpwYAAABWWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgpMwidZAAACsklEQVQ4EX2U32uOYRjH32c2zIjyKyc7IDkRZw4cMEcjxIHSyoH4C6yNNJRJOZKWAyeEQqI4wQnlhE0phCHmR1NsI43ttdnm8fk8nktPWu+3Prvu676v57qv+3rve0kJpWk6FbMdVkICRemfS5LkiZPEbsSsgRpdUNpauEbc7WwiTVdjjXW+GDcd/4GJauAiVJJFGXusUhBrh/O4XYzHKsReryZwEzTBOFiZJ9ROgLIbgyRZgm11Ao1AsTPGzoAfxBl/CMxdzi3mX07jhl00YSjaZ1LHod8M6qEKxsB2TSbjFsG8fNFNJlPixkXFiT8y2Q1usAqmwC9QFvQUXoNdshhPth5cc3PVBf2gH9/OZtwIVX4UctP46AqXxIDN8BZMGK0/ztoK/Gb4Brb9IbyHOIixu4nbgu2BpXAH3+LaoM5AN1QmHwVPJ8obadstyPFnOADqLDSA2vHXlC5j4zDT8rlZ2DqYmftztG7sZbCtc2EhqPjIFsVls5gvVP2TC7SA8WJQFhWbZRP88TBx+nuM++A+qPkw4QdWdBc2wDN4BadBNcAy8ELZjeVsupbN/e3a4SvYbn/zIbC4uCfOq21wEHaC6oDUqgzYD1beAgOO2WAfdi/Es/F3U+dZO4J9B0fBFr6EPWCn3NgDbSXuObYTXsAbfA/n3fjuP4UWCA0z6IVyTOS2Ebvuvzld361vfEgHNUM9hO/cCBg3rpPrQvwOFJG10ncXby+eitVLyHm7IHFhohu2OjrEMHtudiE64Z3xTlWb0NYox7bbxCYqJvA2x+YRrzUuYFj6AM6bJxTrzsW3PSazAuVz0rcLVi76Z7hMj7BxOuNiPaw5bsFVKHatmMtYT/4YOlzoBRMPQpyKYVb1TewJHfQJboD/MIqyM51wigK9lGXGl6AWPG3IjbvhpK/iD/ZAl+AbzJMOAAAAAElFTkSuQmCC');
}

.credit-card.unionpay::after {
  width: 50px;
  height: 30px;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAeCAYAAABuUU38AAAKZklEQVRYhd2YeXBV1R3HP3d5+5rlkQAhhCUD4sKiFRDZFFeoyIxVmcpMx62ldjpTZlprq7W2bq06rdjK1CpDVapOVWCKZVNLxUgwIMgOAUISwpaNl7e/d+89nXtvwPdCEtD/2t/Mb+459557zvn+9nP4fyEpH4dgQQ9YMqBxLHIIXcksknFOBRw9seckmYpsEg14ouIy/jxgBAlJBkPvXUzmqlkBBlDlgEoVFKCP4YX/Coi07uG1ex9l57jc2ddq/pi0u7HHTxJC4EKWNiM7xlsL9yABFGsZErLKjFFT2VlSCcko6Jr1f6+kdb8c54IKFeKG/a6P4QUkJOgsms20TaPZydxegZwKt58nOSHJjyvCM1425O5tn0/hbIofDLuKnZFhEGs7J4Q+KS2gulsTZ4xza100pd1QfvK2/PEFQGTNc764FXm+pfY+QHgMg4TTzbpABDLJi5Bo96ph2Tavb0KKDmnXxr6ByD1XlCoMmao+MFgU0nPs8gQ46vKBnr3wrnQBHgm8JpBvhsPyk6x7Q8He8zuKyGfZ1PZkC4NugJHnIGZfWEBxWkBC4PSCfhHeavqCCcJtRgndntc4O9/XIFn/JH9wgUYMWSuYyFBdk8loaG2nkBQ3avlAjEQX+pkOlFAxkt8HwmCbNwyK2qf5FZCJNazaiKIJ2wxMELkc+HwQ8IF2AYEIKYmq1fUJRPSQqNHVNVGKlFC+5k30M120fm8hzmGXEHl7MYkV60kvW0bOX0qtCaSvUFuwAN1hNsbIsuG8ePcshpUUIQnBpsZmntiwkZa2dvB4+p5DMkB3bCPtyuS/LvQKyfkVyy6Pluqc4BwzEs/N01GHV5LNtOCeNQXPTdMQsQTBzCn25CS2Sh7Qc9DUCq1RcKqQykIi3T2xgGQGulJgZMFIMLe6mltHjeT1HbtYV3+EB64az8Mzp8LJ07aJ6t1ml812a0wDTbMloWi1+BL0CUSWpG6WkSTpakHK7bzyMutb/NV3rKf7usnWM7lyLUF1CIeGVoE/CPEECx+azdzbJ8GXDTgDHgKRELTHLFCyz40vFEQp94BHZvbwEWQ0nWd//Xv+8Nnn1pzr6w/b2khnrPAtmWbncNh9BGVFIRtg1llLxlUApNC0hJ7XlqdLuHFNn2j1MzXbUXDinjmZ5IZPcU4cB+8uYbYkczClcctPl/LIXVN5acVmbrj1Kl59coG1+I9fWk06q7H8l3da/tGhpRi7eAkDvD5cqsKaJc9z8+VjeHPHLiqCAfY/8xjHuuLUt7WzubmFR2dM4aHV61g6bw4Prl7HmqbPwVe2GaMw8RSalpAsNkxOpq5RS4bgmTUFvStOYu9aVIaghIOk3l9L+O65RGWVpnU1DBpUzNhRg8npBo2tUda/8iNe+MenNJ2O8vT9N/LD2ydxJp5i/dZ6qiMlDCqNMCgYoLa5hbZEkvmvvsHizXUsmXsrj3z0CdePqKIs4GdfWzvVpSWsXnAXaV1nzaZaCPr34E2cIBDrG4gimSxQJWSRyV0th3ymiaEE/YS++yDln75jOWxy5Xo8D97N0dUbrTxSezLOFVVlDB9UTGlJ0JqrNZrk2suGsml3I7dNHs2bH+3EK1RqWlu4vLSYIo+bn/xrAwt++xxvv/9PFl07yfrv4OlW6/nu3v3UHW6w2k5FYfpf/waymQK8m+gKQjTYj0bMskKWEbJ0hVQULNJPHqfj4WfJHTjCgNdeRg4FaLn6FkQmC00tnKjdxb7ywaxbV4fX7WBtXT1vr9rCpl1HeereWfxpZS3PvPUJB5rbqN3TjC/gYmntDgaHguxrbWOPuelR1TBsKMu/2MmRjk7enX8HjWeifHKkERJ2pbB0+y6O7zkApaVm+VGLKwvOXAGQAkNrjozrhqcsFIrzZQwN7eQxZG8RsseN1t5q2b1j2HAqjjXyu4rL+PklUyHaAR6nHanM6KIqdr9mHwyNQHEAjkZhuApXKKApdv4oLYH2Tjsud8XB47bZFGg0xgPzbuWV22fjffQpUrE4BAJmUhiFzEErlD/5WO/OLhuS9V1I0iQhDCRk1PIhiHQGoWmokQGgOmxJKQp14VI7yzsUG4AiQygIDacwo8oLby6i5kALq1dtYd591xEc7UeNOHHrsiX9VbVbue/GmQwvLuJgaysVoRAuh4PXt+3g0NEmC8Rzn20h1dQMw4ZAjhOk/AetCrhHkVkIxDxDSKDJ0jQ7SduZWnLnhTph4EYQDYT5wl9s262qfPU9mqRkQIjFv5rPDRNGcGlRgAqngxcWzWV3ooNUUzuTLx3Fsu07LSCvzpvNX+q+YNkdc2no6ETTNK6tHMzJRJKtLSf42TsroazMrggUoxZ/vNdSudBHFIEhixECqUrqp9wI6zn2uf00uP32uSOf2roYP/VSy8HfWL+d3YdPUFlVhoFgxabtHE6lrMGL1nzIty4fY7VPx5M0R6M8X7OFjYePUhkOMa68jL9/ucsuXVxOu1DMOWrIOiHrsLkvIIYuzNA7ud+zhKlGq1AMgtNzfmkS9NK0u5FEOsuiO68l3tbFpOpBCENQHQzi9Xn44EA9nfsP8sz109nY0MjAgI+I14eWSoPTwYjiIg51drL9aLPVP1fDGfJ/0FTOcV9AEGZXnnzB0k9AnbcI5B6FoukvssR3brmSsN/NjsbTnNB0BhcFefqjGsKlRUwoL2NDQ5NVIE6vquR4V5ypQyt5b+9+jp9u4/4JYzkei1Nz4BD7ojEz8JzdZhRvcgfBLs5xX0AkM5HI0sT+SmqnMEg7XNT6wueblSzBmThJAS6HyrR7F9Mmy1RVFrNix35uHD2SNfWHWbXuY74/+0ZURebDww2MipTw3u79tOSyVt4a4PXwxy3bONV0DAJ+kHRTA3XEApqVQ85yn0AEQYEY259hhXSNepePve6AXSgWTCBZZwx3t/P/4p4ZjBlcgqEbPDVnJl3JNFXhEEdzOcYUhfn4QD2PzZhCTtd5ZPo1fPzQ/dyx7C1aE0me//bNtqCsityMUqIW1QzteZy/dH6nOXLlTUJR1/Z3rhiSSbC8pJJ7qqeAljn/QKQbqE6VSNiH3+umoaGNAVUB1LEe2mNJhoZC7Os4g4gnIJnCESkh4HRQ6vMSz+Q4frgB7+CBVh3WaY5RuiOibMxBEh8UrPWbx881CzxGksQ0Q7IDRG9kR2Sd7eaJ0MwnufT5o5wqWirLibYuu5zPKhxvPQ3tXkgZ7O2Igs9rRyKXk1wyRUcsToeZGE2xlg8gGYuRNH3DDPtGt0YS3lrbh3unwupXUq/vzz8cQpBTnGzxFRUefXtoxALg9HcfpAQM8YJHLdTe2choAsonc163235htiVLgntQ9fb+Lr56AGFif/7hFjptqovdZui92BOhuYJfprc7sQuSaRomxwJvWfmjH+rp7P/uL/SmJZmyXJpxqSiYtyYX3Ih5wQDEDHB9nYurPDJk06SeRdU5j/OoMKso8hxJ158AhltxsAeZV6MxRWF5w1YWGgYfhgfKKUMXwhJbLyIwZ3BKcDBnfy5TzIJBXMwdBZLIoamfIaQXKTv1zYTwP0fAfwGNu1G2zKQzagAAAABJRU5ErkJggg==');
}
</style>
